import { render, staticRenderFns } from "./ProjectList.vue?vue&type=template&id=4bade4b9&scoped=true&"
import script from "./ProjectList.vue?vue&type=script&lang=js&"
export * from "./ProjectList.vue?vue&type=script&lang=js&"
import style0 from "./css/ProjectList.scss?vue&type=style&index=0&id=4bade4b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bade4b9",
  null
  
)

export default component.exports